import {
  CAR_DATA_MASTER_LOAD_SCHEMAS_FROM_MAESTRO_BEGIN,
  CAR_DATA_MASTER_LOAD_SCHEMAS_FROM_MAESTRO_SUCCESS,
  CAR_DATA_MASTER_LOAD_SCHEMAS_FROM_MAESTRO_FAILURE,
  CAR_DATA_MASTER_LOAD_SCHEMAS_FROM_MAESTRO_DISMISS_ERROR,
} from './constants'

import { processDefaultAndTotals } from '../../common/formulario/processDefaultAndTotals'
import { DATAMASTER_ENDPOINT } from '../../../common/endpoints'
import axios from 'axios'

export function loadSchemasFromMaestro() {
  return (dispatch) => {
    dispatch({
      type: CAR_DATA_MASTER_LOAD_SCHEMAS_FROM_MAESTRO_BEGIN,
    })

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios(`${DATAMASTER_ENDPOINT}/schema/`)
      doRequest.then(
        (res) => {
          const advancedInfoSchema = res.data.data
          const tipo_cotizador = {...advancedInfoSchema.tipo_cotizador}
          const segmento_cotizador = {...advancedInfoSchema.segmento_cotizador}
          const basicInfoSchema = {
            infoVehiculo: {
              tipo_cotizador,
              segmento_cotizador
            }
          }
          delete advancedInfoSchema.tipo_cotizador
          delete advancedInfoSchema.segmento_cotizador
          const {
            defaults: advancedInfoDefaults,
            countTotalFields: advancedInfoTotalFields,
            required: advancedInfoRequired,
          } = processDefaultAndTotals(advancedInfoSchema)
          const {
            defaults: basicInfoDefaults,
            required: basicInfoRequired,
          } = processDefaultAndTotals(basicInfoSchema)

          dispatch({
            type: CAR_DATA_MASTER_LOAD_SCHEMAS_FROM_MAESTRO_SUCCESS,
            data: {
              totalFields: advancedInfoTotalFields,
              advancedInfoSchema: advancedInfoSchema,
              basicInfoSchema: basicInfoSchema,
              requiredFields: {...basicInfoRequired, ...advancedInfoRequired},
              defaultFields: {...basicInfoDefaults, ...advancedInfoDefaults},
            },
          })
          resolve({...basicInfoDefaults, ...advancedInfoDefaults})
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CAR_DATA_MASTER_LOAD_SCHEMAS_FROM_MAESTRO_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })

    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissLoadSchemasFromMaestroError() {
  return {
    type: CAR_DATA_MASTER_LOAD_SCHEMAS_FROM_MAESTRO_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_LOAD_SCHEMAS_FROM_MAESTRO_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        loadSchemasFromMaestroPending: true,
        loadSchemasFromMaestroError: null,
        totalFields: 0,
        basicInfoSchema: null,
        advancedInfoSchema: null,
        requiredFields: null,
        defaultFields: null,
      }

    case CAR_DATA_MASTER_LOAD_SCHEMAS_FROM_MAESTRO_SUCCESS:
      // The request is success
      return {
        ...state,
        loadSchemasFromMaestroPending: false,
        loadSchemasFromMaestroError: null,
        ...action.data,
      }

    case CAR_DATA_MASTER_LOAD_SCHEMAS_FROM_MAESTRO_FAILURE:
      // The request is failed
      return {
        ...state,
        loadSchemasFromMaestroPending: false,
        loadSchemasFromMaestroError: action.data.error,
        totalFields: 0,
        basicInfoSchema: null,
        advancedInfoSchema: null,
        requiredFields: null,
        defaultFields: null,
      }

    case CAR_DATA_MASTER_LOAD_SCHEMAS_FROM_MAESTRO_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        loadSchemasFromMaestroError: null,
      }

    default:
      return state
  }
}
